import { Button } from 'antd';
import * as React from 'react';
import ButtonGroup from 'antd/es/button/button-group';

var _excluded = ["secondary"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var InternalButton = /*#__PURE__*/React.forwardRef(function (props, ref) {
  props.secondary;
    var rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/React.createElement(Button, _extends({}, rest, {
    ref: ref
  }));
});
InternalButton.displayName = 'Button';
InternalButton.Group = ButtonGroup;

export { InternalButton as default };
